import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/file.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4ecb102c")

_pushScopeId("data-v-4ecb102c")
const _hoisted_1 = {
  id: "bulk-booking-retail-page",
  "data-testid": "pickup-detail-page",
  style: {"display":"contents"}
}
const _hoisted_2 = {
  class: "w-full flex flex-col justify-center gap-4 max-w-4xl mx-auto",
  "data-testid": "bulk-booking-create-retail-layout"
}
const _hoisted_3 = { class: "bg-white border border-gray-lp-1300 rounded-xl p-3" }
const _hoisted_4 = {
  key: 0,
  class: "relative flex items-center gap-1 rounded-full border border-gray-lp-1300 bg-white p-1 mb-3",
  "data-testid": "bulk-booking-create-booking-type"
}
const _hoisted_5 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-green-lp-100"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Retail ")
const _hoisted_7 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-green-lp-100"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Client ")
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-row gap-3 items-center font-semibold",
  "data-testid": "bulk-booking-create-title-upload-file"
}, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-6",
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode(" Upload file ")
], -1)
const _hoisted_10 = { class: "flex-shrink-0" }
const _hoisted_11 = { class: "bg-white border border-gray-lp-1300 rounded-xl p-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", { class: "my-5 border-gray-lp-400" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SectionFilterClient = _resolveComponent("SectionFilterClient")!
  const _component_upload_file = _resolveComponent("upload-file")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_download_template = _resolveComponent("download-template")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: "Upload Bulk Booking",
      "vertical-separator": false,
      fullPage: "",
      usePaddingVertical: false,
      customClass: "bg-gray-lp-1000 h-full p-4"
    }, {
      data: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.canSelectBookingType)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  (_ctx.form.type)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "absolute top-1 bottom-1 rounded-full bg-red-lp-2000 transition-all duration-200 ease-out",
                        style: _ctx.bookingTypeIndicatorStyle
                      }, null, 4))
                    : _createCommentVNode("", true),
                  (_ctx.utilsBulkBooking().permissionPos)
                    ? (_openBlock(), _createBlock("button", {
                        key: 1,
                        type: "button",
                        class: _ctx.bookingTypeClass('retail'),
                        "data-testid": "bulk-booking-create-button-type-retail",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getBookingType('retail')))
                      }, [
                        (_ctx.form.type === 'retail')
                          ? (_openBlock(), _createBlock("span", _hoisted_5))
                          : _createCommentVNode("", true),
                        _hoisted_6
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.canCreateClientBooking)
                    ? (_openBlock(), _createBlock("button", {
                        key: 2,
                        type: "button",
                        class: _ctx.bookingTypeClass('client'),
                        "data-testid": "bulk-booking-create-button-type-client",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getBookingType('client')))
                      }, [
                        (_ctx.form.type === 'client')
                          ? (_openBlock(), _createBlock("span", _hoisted_7))
                          : _createCommentVNode("", true),
                        _hoisted_8
                      ], 2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.type === 'client' && !_ctx.utilsBulkBooking().permissionClient)
              ? (_openBlock(), _createBlock(_component_SectionFilterClient, {
                  key: 1,
                  modelValue: _ctx.form,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form = $event)),
                  compact: "",
                  class: "mb-3"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_data_wrapper, null, {
              label: _withId(() => [
                _hoisted_9
              ]),
              default: _withId(() => [
                _createVNode(_component_upload_file, {
                  id: "upload-file",
                  type: "xlsx",
                  titleChange: "Change",
                  captionHtml: _ctx.uploadFileCaption,
                  "data-testid": "bulk-booking-create-text-filename",
                  isDraggable: false,
                  modelValue: _ctx.form.archiveFile,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.archiveFile = $event)),
                  errorMessage: "Invalid file format",
                  draggable: "xlsx",
                  customClass: "border border-solid",
                  maxRows: _ctx.maximumStt,
                  maxSize: _ctx.maximumFileSize
                }, null, 8, ["captionHtml", "modelValue", "maxRows", "maxSize"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              "data-testid": "booking-bulk-create-label-activity-name",
              label: "Activity name",
              class: "w-full",
              style: {"margin-top":"11px"}
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  type: "text",
                  errorIcon: false,
                  placeholder: "Enter a name or note for this activity",
                  maxLength: "56",
                  minLength: "3",
                  modelValue: _ctx.form.activityName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.activityName = $event)),
                  onChange: _ctx.onChangeActivityName,
                  errorMessageMinLength: "characters",
                  showMaxLength: "",
                  "data-testid": "booking-bulk-create-input-activity-name"
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_LpButton, {
              "data-testid": "bulk-booking-create-button-upload",
              title: "Upload",
              "text-color": "white",
              isWidthFull: "",
              id: "button_upload_bulk_booking",
              disabled: _ctx.isBulkUploadValid,
              customClass: "bg-red-lp-2000",
              onClick: _ctx._onAdd
            }, null, 8, ["disabled", "onClick"])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_download_template, {
                "download-layout-column": "2-column",
                title: "Download template",
                description: "Download the template, fill in the data columns, check the format, and upload it here!",
                typeDownload: "download-template",
                dataComponent: _ctx.templateBookingData
              }, null, 8, ["dataComponent"]),
              _hoisted_12,
              _createVNode(_component_download_template, {
                downloadLayoutColumn: "2-column",
                title: "Check the data format in each column",
                description: "Before uploading bulk bookings, ensure that all data in each column matches the format below!",
                typeDownload: "cek-format",
                dataComponent: _ctx.templateComodityData
              }, null, 8, ["dataComponent"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack"]),
    _withDirectives(_createVNode(_component_Modal, {
      title: "Bulk booking uploaded successfully",
      onSubmit: _ctx.closePageUploadBulkBooking,
      message: _ctx.messageModalBookingOnProcess,
      image: "scan-cargoV2-badges/success",
      textSuccess: "OK",
      class: "px-8",
      customButton: "w-full",
      customParentButton: "w-full",
      customWrapperButton: "w-80"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.resultUpload]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.errorTitle,
      onSubmit: _ctx.onSubmitFailedUploadBulkBooking,
      onClose: _ctx.onCloseUploadBulkBooking,
      message: _ctx.errorSubtitle,
      image: "ill_badge_failed",
      textSuccess: _ctx.btnModalFailed,
      textCancel: _ctx.btnModalCancel,
      class: "px-8",
      customButton: "w-full",
      customParentButton: "w-full",
      customWrapperButton: "w-80"
    }, null, 8, ["title", "onSubmit", "onClose", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.resultErrorUpload]
    ])
  ]))
})